import UserInfoSection from './UserInfoSection';

export default UserInfoSection;
